import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { TRANSCRIPT_ROUTES } from "TranscriptsV3/modules/constants";

export default store => ({
  path: TRANSCRIPT_ROUTES.SCHOOLS,
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "transcripts-v3-schools" */ "./components"
    ).then(m => m.default)
  ),
});
